module.exports = __webpack_public_path__ + "static/media/abhilashnalegaonkar.ce155b76.jpg";